export default {
    selectProjects: 'Select Projects',
    themeColor: 'Theme Color',
    Logo: 'Logo',
    addLogo: 'Add logo',
    noProjectsSelected: 'No projects selected',
    nameForZip: 'Name for zip file'
}